import {adminHttpClient} from "../commons/adminHttpClient";

const deleteLiveBroadcastAudit = (id : string) : Promise<any> => {
    return adminHttpClient.delete(`/LiveBroadcastAudits/Delete`, {
        data:{id : id}
    })
}

export default deleteLiveBroadcastAudit;